import React from "react";

import { cn } from "@/lib/utils";

const URL = `${import.meta.env.VITE_CDN_BASE_URL}/assets/monetary-metals.webp`;

export default function MMLogo({ className, ...props }: React.ImgHTMLAttributes<HTMLImageElement>) {
  return (
    <img
      src={URL}
      alt="Monetary Metals Logo"
      className={cn("block h-auto w-full max-w-xs", className)}
      width={900}
      height={205}
      {...props}
    />
  );
}
